
import React from "react";
import { GiPhone } from "react-icons/gi";
import { Link } from "react-router-dom";

export const Footer = ({lang ,theme}) => {

  
const navLinks = [
  {
    id: "/",
    title:  lang === 'en' ?  "Home" : " الرئيسية ",
    Children:[]
  },

  
  {
    id: "Products",
    title:  lang === 'en' ? "Products" : "المنتجات",
    Children:[]
  },
  {
    id: "Brands",
    title:  lang === 'en' ? "Brands" : "الصيدليات",
    Children:[]
  },
  {
    id: "About",
    title:  lang === 'en' ? "About" : " من نحن",
    Children:[]
  },
  {
    id: "Contact",
    title:  lang === 'en' ? "Contact" : "تواصل",
    Children:[]
  },
];



  return (
    <footer  className={`mt-[8px] p-1 w-full  h-[280px] ${theme === "LM" ? 'bg-zinc-200' : 'bg-[#1F1F1F]'  } `}>
      <div className={`flex flex gap-5 justify-between  items-center  w-full `}>
     
        <div className="flex gap-1 justify-between w-[40%]  my-auto h-[180px] ">
        <img
            src="/Artboard.svg"
            className="object-contain  w-[100%]"
            alt="Footer logo"
          />
         
         
        </div>

        <nav style={{fontFamily:'CairoLight'}} className="flex gap-1 justify-between items-center  my-auto  text-[#A2A6AC]  w-[30%]">
          <div className="flex flex-col justify-center  my-auto w-[50%]">
            <Link to="/#">{navLinks[0].title}</Link>
            <Link to="/Products">{navLinks[1].title}</Link>
           
          </div>
          <div className="flex flex-col justify-center my-auto w-[50%]"> 
             <Link to="/Pharmacies">{navLinks[2].title}</Link>  
            <Link to="">{navLinks[4].title}</Link>
          </div>
        </nav>

        <div style={{fontFamily:'CairoMedium'}} className="flex flex-col justify-center items-center w-[30%] text-[#A2A6AC] ">
        <h3> {lang === 'en' ? 'Contact us' : 'تواصل معنا على'}</h3>
        <ul  className="w-full  px-[5%] gap-1 flex   mt-2 ">
        <li className="m-auto w-[24px] h-[24px] rounded"><a className="" target='__blink' href="Tel:+967774179096">
            <GiPhone color="#E6324B" size={24} />
             </a></li>

             <li className="m-auto w-[24px] h-[24px] rounded"><a className="" target='__blink' href="https://wa.me/+967774179095">
               <img src='../../Icons/whatsapp.png ' alt="Dawa Smart whatsapp" name="logo-whatsapp" width={24} height={24}  />
             </a></li>
      
             <li className="m-auto w-[24px] h-[24px] rounded"><a className="" target='__blink' href="mailto:info@future-swift.com">
               <img src='../../Icons/gmail.png ' alt="Dawa Smart gmail" name="logo-gmail" width={24} height={24}  />
             </a></li>
          
       
            
             
         </ul>
        </div>


      </div>
     
 <div className="flex flex-col justify-center w-full w-full mt-2">
        <hr className="flex w-full  " />
        
        <div className="flex flex-wrap gap-2 justify-between items-center my-2  w-full p-2 ">
        <p  className="text-[#A2A6AC] ">
              <span className=""> &copy; </span>
              {lang === 'en' ? 'All rights reserved to Dawa Smart Foundation 2026' : 'جميع الحقوق محفوظة لدواء سمارت 2026'}
            {" "}
            </p>
          
          
          
          <p className="self-stretch my-auto text-zinc-400">
            {lang === 'en' ? 'Developed by' : 'تطوير'}
            <a  target='__blink' href="https://future-swift.com"><span className=""> {lang === 'en' ? 'Future Swift' : 'فيوتشر سويفت'} </span></a>
          </p>
         
        </div>
      </div>
    </footer>
  );
};
/*

  <div className="self-stretch my-auto text-3xl text-white w-[239px]">
          <h3>تواصل معنا على</h3>
          <div className="flex gap-5 py-px mt-5 w-full min-h-[46px]" />
        </div>





 
      





 <div className="flex flex-col justify-center mt-8 w-full text-xl max-md:max-w-full">
        <hr className="flex w-full bg-zinc-400 bg-opacity-50 min-h-px max-md:max-w-full" />
        <div className="flex flex-wrap gap-10 justify-between items-center mt-7 w-full max-md:max-w-full">
          <p className="self-stretch my-auto text-zinc-400">
            تطوير
            <span className="text-white"> Future Swift</span>
          </p>
          <div className="flex flex-wrap gap-10 justify-between items-center self-stretch my-auto text-white min-w-60 w-[662px] max-md:max-w-full">
            <a href="#" className="self-stretch my-auto">
              الخصوصية و شروط الاستخدام
            </a>
            <p className="gap-3 self-stretch my-auto min-w-60">
              <span className="font-[Century Gothic]">© </span>
              2025 HUBAISHI جميع الحقوق محفوظة{" "}
            </p>
          </div>
        </div>
      </div>
*/